import { render, staticRenderFns } from "./authenticationTabs.vue?vue&type=template&id=08e3d63f&scoped=true&"
import script from "./authenticationTabs.vue?vue&type=script&lang=js&"
export * from "./authenticationTabs.vue?vue&type=script&lang=js&"
import style0 from "./authenticationTabs.vue?vue&type=style&index=0&id=08e3d63f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3d63f",
  null
  
)

export default component.exports